// Author thq
// Date 2023-11-28 10:47:32

class TpmOeeQueryHistoryToh {
    constructor({
                    id = null,
                    machineCode = '',
                    operator = '',
                    deptName = '',
                    projectCode = '',
                    itemName = '',
                    orderCode = '',
                    prdPpOperationName = '',
                    actualMstLocationName = '',
                    queryTime = '',
                    queryStartTime = '',
                    queryEndTime = '',
                    tohWorkhourTime = '',
                    tohProgramTime = '',
                    tohSpindleTime = '',
                    tohSpindleTimeNoFilter = '',
                    tohOeeA = '',
                    tohOeeP = '',
                    tohOee = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.machineCode = machineCode;
        this.operator = operator;
        this.deptName = deptName;
        this.projectCode = projectCode;
        this.itemName = itemName;
        this.orderCode = orderCode;
        this.prdPpOperationName = prdPpOperationName;
        this.actualMstLocationName = actualMstLocationName;
        this.queryTime = queryTime;
        this.queryStartTime = queryStartTime;
        this.queryEndTime = queryEndTime;
        this.tohWorkhourTime = tohWorkhourTime;
        this.tohProgramTime = tohProgramTime;
        this.tohSpindleTime = tohSpindleTime;
        this.tohSpindleTimeNoFilter = tohSpindleTimeNoFilter;
        this.tohOeeA = tohOeeA;
        this.tohOeeP = tohOeeP;
        this.tohOee = tohOee;
        this.remark = remark;
    }
}

function newEntity() {
    return new TpmOeeQueryHistoryToh();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'machineCode',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.machineCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operator',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.operator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deptName',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.deptName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemName',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.itemName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdPpOperationName',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.prdPpOperationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualMstLocationName',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.actualMstLocationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'queryTime',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.queryTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'queryStartTime',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.queryStartTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'queryEndTime',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.queryEndTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tohWorkhourTime',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.tohWorkhourTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tohProgramTime',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.tohProgramTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tohSpindleTime',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.tohSpindleTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tohSpindleTimeNoFilter',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.tohSpindleTimeNoFilter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tohOeeA',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.tohOeeA',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tohOeeP',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.tohOeeP',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tohOee',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.tohOee',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    machineCodeFilter: '',
    operatorFilter: '',
    deptNameFilter: '',
    projectCodeFilter: '',
    itemNameFilter: '',
    orderCodeFilter: '',
    prdPpOperationNameFilter: '',
    actualMstLocationNameFilter: '',
    queryTimeRteFilter: '',
    queryTimeLteFilter: '',
    queryStartTimeRteFilter: '',
    queryStartTimeLteFilter: '',
    queryEndTimeRteFilter: '',
    queryEndTimeLteFilter: '',
    tohWorkhourTimeFilter: '',
    tohProgramTimeFilter: '',
    tohSpindleTimeFilter: '',
    tohSpindleTimeNoFilterFilter: '',
    tohOeeAFilter: '',
    tohOeePFilter: '',
    tohOeeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'machineCodeFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.machineCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operatorFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.operator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deptNameFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.deptName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemNameFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.itemName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpOperationNameFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.prdPpOperationName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualMstLocationNameFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.actualMstLocationName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryTimeRteFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.queryTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryTimeLteFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.queryTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryStartTimeRteFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.queryStartTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryStartTimeLteFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.queryStartTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryEndTimeRteFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.queryEndTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryEndTimeLteFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.queryEndTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    // {
    //     key: 'tohWorkhourTimeFilter',
    //     label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.tohWorkhourTime',
    //     disabled: false,
    //     form: {
    //         type: 'inputNumber',
    //         modalMultiSelectedType: 'string'
    //     }
    // },
    // {
    //     key: 'tohProgramTimeFilter',
    //     label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.tohProgramTime',
    //     disabled: false,
    //     form: {
    //         type: 'inputNumber',
    //         modalMultiSelectedType: 'string'
    //     }
    // },
    // {
    //     key: 'tohSpindleTimeFilter',
    //     label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.tohSpindleTime',
    //     disabled: false,
    //     form: {
    //         type: 'inputNumber',
    //         modalMultiSelectedType: 'string'
    //     }
    // },
    // {
    //     key: 'tohSpindleTimeNoFilterFilter',
    //     label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.tohSpindleTimeNoFilter',
    //     disabled: false,
    //     form: {
    //         type: 'inputNumber',
    //         modalMultiSelectedType: 'string'
    //     }
    // },
    // {
    //     key: 'tohOeeAFilter',
    //     label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.tohOeeA',
    //     disabled: false,
    //     form: {
    //         type: 'inputNumber',
    //         modalMultiSelectedType: 'string'
    //     }
    // },
    // {
    //     key: 'tohOeePFilter',
    //     label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.tohOeeP',
    //     disabled: false,
    //     form: {
    //         type: 'inputNumber',
    //         modalMultiSelectedType: 'string'
    //     }
    // },
    // {
    //     key: 'tohOeeFilter',
    //     label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.filter.tohOee',
    //     disabled: false,
    //     form: {
    //         type: 'inputNumber',
    //         modalMultiSelectedType: 'string'
    //     }
    // }
];


const entityFormConfigs = [
    {
        key: 'machineCode',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.machineCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operator',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.operator',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deptName',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.deptName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemName',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.itemName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.orderCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpOperationName',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.prdPpOperationName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualMstLocationName',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.actualMstLocationName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryTime',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.queryTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryStartTime',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.queryStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'queryEndTime',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.queryEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tohWorkhourTime',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.tohWorkhourTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tohProgramTime',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.tohProgramTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tohSpindleTime',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.tohSpindleTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tohSpindleTimeNoFilter',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.tohSpindleTimeNoFilter',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tohOeeA',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.tohOeeA',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tohOeeP',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.tohOeeP',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tohOee',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.tohOee',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.statusCollection.tpmOeeQueryHistoryToh.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    TpmOeeQueryHistoryToh, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
